var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Form } from 'antd';
import ScanToteDataForSinglePick from './ScanToteDataForSinglePick';
import Input from '@fp-suite/core-ui/src/components/Input';
import BackBtn from './BackBtn';
import moment from 'moment';
import { BsKeyboard, BsKeyboardFill } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
var PlaceInTote = function (_a) {
    var _b, _c;
    var onAgainToteScan = _a.onAgainToteScan, currentPickRunTypeId = _a.currentPickRunTypeId, totesList = _a.totesList, fromPickMultis = _a.fromPickMultis, scannedLocationIncorrect = _a.scannedLocationIncorrect, errorMsgText = _a.errorMsgText, setError = _a.setError, setScannedLocationIncorrect = _a.setScannedLocationIncorrect, backBtn = _a.backBtn, lotDetail = _a.lotDetail;
    var t = useTranslation().t;
    var form = Form.useForm()[0];
    var _d = useState(''), prodName = _d[0], setProdName = _d[1];
    var _e = useState(), picklistId = _e[0], setPicklistId = _e[1];
    var _f = useState(''), locationSeqId = _f[0], setLocationSeqId = _f[1];
    var _g = useState({}), locationData = _g[0], setLocationData = _g[1];
    var _h = useState('none'), inputMode = _h[0], setInputMode = _h[1];
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        var locationObj = localStorage.getItem('goToLocationData');
        if (locationObj) {
            locationObj = JSON.parse(locationObj);
        }
        else {
            locationObj = [];
        }
        var currIndex = localStorage.getItem('currIndexInPickRunDetailsArr');
        if (!currIndex) {
            currIndex = 0;
        }
        var orderId = (_a = locationObj[currIndex]) === null || _a === void 0 ? void 0 : _a['orderId'];
        var shipmentId = (_b = locationObj[currIndex]) === null || _b === void 0 ? void 0 : _b['shipmentId'];
        localStorage.setItem('currentOrderId', orderId);
        localStorage.setItem('currentShipmentId', shipmentId);
        localStorage.setItem('currIndexInPickRunDetailsArr', currIndex);
        var picklistIdVal = (_c = locationObj[currIndex]) === null || _c === void 0 ? void 0 : _c['workEffortId'];
        var prodNameVal = (_e = (_d = locationObj[currIndex]) === null || _d === void 0 ? void 0 : _d['product']) === null || _e === void 0 ? void 0 : _e['productName'];
        var productId = (_g = (_f = locationObj[currIndex]) === null || _f === void 0 ? void 0 : _f['product']) === null || _g === void 0 ? void 0 : _g['productId'];
        localStorage.setItem('currProdId', productId);
        localStorage.setItem('pickRunItemId', (_h = locationObj[currIndex]) === null || _h === void 0 ? void 0 : _h['pickRunItemId']);
        localStorage.setItem('currentTotalPickRunItemQty', (_j = locationObj[currIndex]) === null || _j === void 0 ? void 0 : _j['pickRunItemQty']);
        localStorage.setItem('pickRunDtlsLocationSeqId', (_m = (_l = (_k = locationObj[currIndex]) === null || _k === void 0 ? void 0 : _k['facilityLocation']) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m['locationSeqId']);
        setLocationSeqId((_q = (_p = (_o = locationObj[currIndex]) === null || _o === void 0 ? void 0 : _o['facilityLocation']) === null || _p === void 0 ? void 0 : _p[0]) === null || _q === void 0 ? void 0 : _q['locationSeqId']);
        setPicklistId(picklistIdVal);
        setProdName(prodNameVal);
        setLocationData(locationObj[currIndex]);
    }, []);
    var onAgainScanToteClick = function (event) {
        if (event.key === 'Enter') {
            event.target.blur();
            form.setFieldsValue({
                scannedTote: ''
            });
            onAgainToteScan(event);
        }
        else {
            setScannedLocationIncorrect(false);
        }
    };
    var goToLocationData = localStorage.getItem('goToLocationData');
    if (goToLocationData) {
        goToLocationData = JSON.parse(goToLocationData);
    }
    else {
        goToLocationData = [];
    }
    console.log('=======line 66========goToLocationData=====', goToLocationData);
    var currIndex = localStorage.getItem('currIndexInPickRunDetailsArr');
    if (!currIndex) {
        currIndex = 0;
    }
    var orderId = (_b = goToLocationData[currIndex]) === null || _b === void 0 ? void 0 : _b['orderId'];
    var shipmentId = (_c = goToLocationData[currIndex]) === null || _c === void 0 ? void 0 : _c['shipmentId'];
    console.log('=====line 72======orderId=====', orderId);
    localStorage.setItem('currentOrderId', orderId);
    localStorage.setItem('currentShipmentId', shipmentId);
    var parsedContainers = localStorage.getItem('pickRunContainerList');
    if (parsedContainers) {
        parsedContainers = JSON.parse(parsedContainers);
    }
    else {
        parsedContainers = [];
    }
    var recommendedContainer = '';
    if (localStorage.getItem('recommendedContainer')) {
        recommendedContainer = localStorage.getItem('recommendedContainer');
        console.log('==========recommendedContainer store in localStorage=========placeInTote=====', recommendedContainer);
    }
    var orderContainerList = localStorage.getItem('orderContainerList');
    if (orderContainerList) {
        orderContainerList = JSON.parse(orderContainerList);
    }
    else {
        orderContainerList = [];
    }
    console.log('====line 90====recommendedContainer=====', recommendedContainer);
    if (!recommendedContainer) {
        orderContainerList.forEach(function (item) {
            if ("" + orderId + shipmentId === item.orderId) {
                console.log('======line 93======containerId====', item.containerId);
                recommendedContainer = item.containerId;
                localStorage.setItem('recommendedContainer', recommendedContainer);
            }
        });
    }
    var workEffortIdsList = localStorage.getItem('workEffortIdsList');
    if (workEffortIdsList) {
        workEffortIdsList = JSON.parse(workEffortIdsList);
    }
    else {
        workEffortIdsList = {};
    }
    var picklistContainerCounts = localStorage.getItem('picklistContainerCounts');
    if (picklistContainerCounts) {
        picklistContainerCounts = JSON.parse(picklistContainerCounts);
    }
    else {
        picklistContainerCounts = {};
    }
    var hospitalContainers = localStorage.getItem('hospitalContainers');
    if (hospitalContainers) {
        hospitalContainers = JSON.parse(hospitalContainers);
    }
    else {
        hospitalContainers = [];
    }
    var packingStationContainers = localStorage.getItem('packingStationContainers');
    if (packingStationContainers) {
        packingStationContainers = JSON.parse(packingStationContainers);
    }
    else {
        packingStationContainers = [];
    }
    var indexAlreadyScannedTote = 0;
    var requiredPickContainerCount = localStorage.getItem('requiredPickContainerCount');
    requiredPickContainerCount *= 1;
    if (currentPickRunTypeId !== 'PrtSingle' && currentPickRunTypeId !== 'PrtOrderLevel') {
        requiredPickContainerCount = 1;
    }
    return (_jsx("div", { children: _jsxs("div", __assign({ className: 'bg-white p-5 pb-0.5 rounded-lg shadow-sm' }, { children: [_jsxs("div", __assign({ className: 'justify-between border-b-2 border-gray-300 mb-6 mt-2' }, { children: [_jsxs("div", __assign({ className: 'flex flex-row items-center mb-3' }, { children: [_jsx("h1", __assign({ className: 'text-lg text-gray-600 w-1/2' }, { children: t('Pick Run Id') }), void 0), _jsx("h1", __assign({ className: 'w-1/2 font-medium text-base' }, { children: localStorage.getItem('pickRunId') }), void 0)] }), void 0), currentPickRunTypeId === 'PrtBulkPick' && (_jsxs("div", __assign({ className: 'flex flex-row items-center mb-3' }, { children: [_jsx("h1", __assign({ className: 'text-lg text-gray-600 w-1/2' }, { children: t('Picklist Id') }), void 0), _jsx("h1", __assign({ className: 'w-1/2 font-medium text-base' }, { children: picklistId }), void 0)] }), void 0)), currentPickRunTypeId === 'PrtOrderLevel' && (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: 'flex flex-row items-center mb-3' }, { children: [_jsx("h1", __assign({ className: 'text-lg text-gray-600 w-1/2' }, { children: t('Shipment Id') }), void 0), _jsx("h1", __assign({ className: 'w-1/2 font-medium text-base' }, { children: localStorage.getItem('currentShipmentId') || '' }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'flex flex-row items-center mb-3' }, { children: [_jsx("h1", __assign({ className: 'text-lg text-gray-600 w-1/2' }, { children: t('Order Id') }), void 0), _jsx("h1", __assign({ className: 'w-1/2 font-medium text-base' }, { children: localStorage.getItem('currentOrderId') || '' }), void 0)] }), void 0)] }, void 0)), _jsxs("div", __assign({ className: 'flex flex-row items-center mb-3' }, { children: [_jsx("h1", __assign({ className: 'text-lg text-gray-600 w-1/2' }, { children: t('Cart') }), void 0), _jsx("h1", __assign({ className: 'w-1/2 font-medium text-base' }, { children: localStorage.getItem('cartId') }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'flex flex-row items-center mb-3' }, { children: [_jsx("h1", __assign({ className: 'text-lg text-gray-600 w-1/2' }, { children: t('Location') }), void 0), _jsx("h1", __assign({ className: 'w-1/2 font-medium text-base' }, { children: locationSeqId }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'flex flex-row items-center mb-3' }, { children: [_jsx("h1", __assign({ className: 'text-lg text-gray-600 w-1/2' }, { children: t('Product') }), void 0), _jsx("h1", __assign({ className: 'w-1/2 font-medium text-base' }, { children: prodName }), void 0)] }), void 0), currentPickRunTypeId === 'PrtBulkPick' && (_jsxs(_Fragment, { children: [(lotDetail === null || lotDetail === void 0 ? void 0 : lotDetail.lotNumber) && (_jsxs("div", __assign({ className: 'flex flex-row items-center mb-3' }, { children: [_jsx("h1", __assign({ className: 'text-lg text-gray-600 w-1/2' }, { children: t('Lot') }), void 0), _jsx("h1", __assign({ className: 'w-1/2 font-medium text-base' }, { children: lotDetail.lotNumber }), void 0)] }), void 0)), (lotDetail === null || lotDetail === void 0 ? void 0 : lotDetail.expDate) && (_jsxs("div", __assign({ className: 'flex flex-row items-center mb-3' }, { children: [_jsx("h1", __assign({ className: 'text-lg text-gray-600 w-1/2' }, { children: t('ExpDate') }), void 0), _jsx("h1", __assign({ className: 'w-1/2 font-medium text-base' }, { children: moment(lotDetail === null || lotDetail === void 0 ? void 0 : lotDetail.expDate).format('YYYY-MM-DD') }), void 0)] }), void 0))] }, void 0)), currentPickRunTypeId !== 'PrtBulkPick' && (_jsx(_Fragment, { children: (locationData === null || locationData === void 0 ? void 0 : locationData.lotNumber) && (_jsxs("div", __assign({ className: 'flex flex-row' }, { children: [_jsx("h1", __assign({ className: 'my-0 font-medium text-base' }, { children: t('Lot') }), void 0), _jsx("h1", __assign({ className: 'mx-3 mb-2 text-base' }, { children: (locationData === null || locationData === void 0 ? void 0 : locationData.lotNumber) + " " + ((locationData === null || locationData === void 0 ? void 0 : locationData.manufacturedDate)
                                            ? t('Mfg') + " " + moment(locationData === null || locationData === void 0 ? void 0 : locationData.manufacturedDate).format('YYYY-MM-DD')
                                            : '') + " " + t('Exp') + " " + moment(locationData === null || locationData === void 0 ? void 0 : locationData.expirationDate).format('YYYY-MM-DD') }), void 0)] }), void 0)) }, void 0))] }), void 0), _jsx("div", __assign({ className: 'flex flex-row mt-3' }, { children: _jsx("h1", __assign({ className: ' font-bold my-2 text-sm' }, { children: currentPickRunTypeId === 'PrtSingle' || currentPickRunTypeId === 'PrtOrderLevel'
                            ? t('Place in Tote')
                            : t('Place in Bulk Single Tote') }), void 0) }), void 0), currentPickRunTypeId !== 'PrtSingle' &&
                    currentPickRunTypeId !== 'PrtOrderLevel' &&
                    parsedContainers &&
                    parsedContainers.length > 0 &&
                    parsedContainers.map(function (tote, index) {
                        return (_jsx(ScanToteDataForSinglePick, { scannedToteData: tote.serialNumber ? tote.serialNumber : tote.description ? tote.description : '', toteCounter: index + 1 }, void 0));
                    }), (currentPickRunTypeId === 'PrtSingle' || currentPickRunTypeId === 'PrtOrderLevel') &&
                    !fromPickMultis &&
                    recommendedContainer ? (_jsx(ScanToteDataForSinglePick, { scannedToteData: recommendedContainer, toteCounter: 1 }, void 0)) : (currentPickRunTypeId === 'PrtSingle' || currentPickRunTypeId === 'PrtOrderLevel') &&
                    !fromPickMultis &&
                    parsedContainers &&
                    parsedContainers.length > 0 ? (parsedContainers.map(function (tote, index) {
                    var toteDescription = tote.serialNumber
                        ? tote.serialNumber
                        : tote.description
                            ? tote.description
                            : tote.containerId
                                ? tote.containerId
                                : '';
                    var containerDesc = '';
                    for (var i = 0; i < hospitalContainers.length; i++) {
                        if (hospitalContainers[i]['orderId'] === "" + orderId + shipmentId) {
                            containerDesc = hospitalContainers[i]['containerId'];
                        }
                    }
                    if (!containerDesc) {
                        for (var i = 0; i < packingStationContainers.length; i++) {
                            if (packingStationContainers[i]['orderId'] === "" + orderId + shipmentId) {
                                containerDesc = packingStationContainers[i]['containerId'];
                            }
                        }
                    }
                    var shouldContinue = true;
                    if (containerDesc) {
                        shouldContinue = false;
                        if (index === 0) {
                            return _jsx(ScanToteDataForSinglePick, { scannedToteData: containerDesc, toteCounter: 1 }, void 0);
                        }
                    }
                    if (shouldContinue) {
                        var isAvailable = false;
                        for (var i = 0; i < orderContainerList.length; i++) {
                            if (orderContainerList[i]['containerId'] === toteDescription) {
                                isAvailable = true;
                            }
                        }
                        for (var i = 0; i < hospitalContainers.length; i++) {
                            if (hospitalContainers[i]['containerId'] === toteDescription) {
                                isAvailable = true;
                            }
                        }
                        if (isAvailable) {
                            return null;
                        }
                        else {
                            indexAlreadyScannedTote++;
                            return (_jsx(ScanToteDataForSinglePick, { scannedToteData: tote.serialNumber
                                    ? tote.serialNumber
                                    : tote.description
                                        ? tote.description
                                        : tote.containerId
                                            ? tote.containerId
                                            : '', toteCounter: indexAlreadyScannedTote }, void 0));
                        }
                    }
                    else {
                        return null;
                    }
                })) : (currentPickRunTypeId === 'PrtSingle' || currentPickRunTypeId === 'PrtOrderLevel') &&
                    !fromPickMultis &&
                    hospitalContainers &&
                    hospitalContainers.length > 0 &&
                    parsedContainers &&
                    parsedContainers.length > 0 ? (parsedContainers.map(function (tote, index) {
                    var toteDescription = tote.serialNumber
                        ? tote.serialNumber
                        : tote.description
                            ? tote.description
                            : tote.containerId
                                ? tote.containerId
                                : '';
                    var isAvailable = false;
                    for (var i = 0; i < hospitalContainers.length; i++) {
                        if (hospitalContainers[i]['containerId'] === toteDescription) {
                            isAvailable = true;
                        }
                    }
                    if (isAvailable) {
                        return null;
                    }
                    else {
                        indexAlreadyScannedTote++;
                        return (_jsx(ScanToteDataForSinglePick, { scannedToteData: tote.serialNumber
                                ? tote.serialNumber
                                : tote.description
                                    ? tote.description
                                    : tote.containerId
                                        ? tote.containerId
                                        : '', toteCounter: indexAlreadyScannedTote }, void 0));
                    }
                })) : ((currentPickRunTypeId === 'PrtSingle' || currentPickRunTypeId === 'PrtOrderLevel') &&
                    !fromPickMultis &&
                    parsedContainers &&
                    parsedContainers.length > 0 &&
                    parsedContainers.map(function (tote, index) { return (_jsx(ScanToteDataForSinglePick, { scannedToteData: tote.serialNumber
                            ? tote.serialNumber
                            : tote.description
                                ? tote.description
                                : tote.containerId
                                    ? tote.containerId
                                    : '', toteCounter: index + 1 }, void 0)); })), _jsxs("div", __assign({ className: 'flex items-center' }, { children: [_jsx(Form.Item, __assign({ validateStatus: scannedLocationIncorrect ? 'error' : '', help: scannedLocationIncorrect && errorMsgText, className: 'w-full mt-3', name: 'scannedTote' }, { children: _jsx(Input, { placeholder: '', title: currentPickRunTypeId === 'PrtSingle' || currentPickRunTypeId === 'PrtOrderLevel'
                                    ? t('Scan Tote')
                                    : t('Scan Bulk Single Tote'), onKeyDown: onAgainScanToteClick, autoFocus: true, allowClear: true, fromHandheld: true, inputMode: inputMode }, void 0) }), void 0), !inputMode ? (_jsx(BsKeyboardFill, { size: 32, className: 'mt-1 ml-2 cursor-pointer', color: '#093479', onClick: function () { return setInputMode('none'); } }, void 0)) : (_jsx(BsKeyboard, { size: 32, className: 'mt-1 ml-2 cursor-pointer', onClick: function () { return setInputMode(''); } }, void 0))] }), void 0), _jsx(BackBtn, { onClick: backBtn }, void 0)] }), void 0) }, void 0));
};
PlaceInTote.defaultProps = {
    currentPickRunTypeId: ''
};
export default PlaceInTote;
